import type { FaireProductEntity } from "../../entity_types/product";

export const p_263p462n8r: FaireProductEntity = {
  token: "p_263p462n8r",
  type: "product",
  name: "Large Multi Classic Canvas Tote Bag",
  brandToken: "b_c3xmn96nkh",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/c78854364ae2dc424ab5352fd63a336eff34d58ba1996f7bd4c28c22525cb27a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/480b7d1c2a7db18baa4d2c5b2864963ef83672ccf9432f496c75f021585ca59c.jpeg",
    "https://cdn.faire.com/fastly/3cde64fdfc8cb0056c8d37f993194e35a13f9e4d576dbb22aa6614603a42cbdf.jpeg",
    "https://cdn.faire.com/fastly/27bfeaf741499599380bb3ed57a144defc6f1fdc0fdc25f1117ed3058dd097ec.jpeg",
    "https://cdn.faire.com/fastly/32f45c180022a483a9e6c32ced114b8d4ba0fe767a51cff309dc5caaf50e1104.jpeg",
    "https://cdn.faire.com/fastly/c912b4701e4483d22460eb891ac1c0f4358bb2661232bfb1cb7f526932430fd6.jpeg",
    "https://cdn.faire.com/fastly/ba838b6159226c5f2aa7f495555e23e332386ace96993da31b0869ce75da89c0.jpeg",
    "https://cdn.faire.com/fastly/f05a291adbabe82d030e479fd7060649e21ec1fba75be25ca2b9f9266b5732a3.jpeg",
    "https://cdn.faire.com/fastly/1b451d47fa1c6a3cfa2677900c664cc75d518e9440545002f983f34b614d2cf0.jpeg",
    "https://cdn.faire.com/fastly/9c8c65329d054a53e1144539f37777a2ee59acd43cb8e5edac2d579c26668357.jpeg",
    "https://cdn.faire.com/fastly/9af11f52b7fb44535b35bb418e82201036e30cf156578bdc19c10b81709629f8.jpeg",
    "https://cdn.faire.com/fastly/c2cb08d30ae99bf03d8b3a02d197188946bd8b55917df41d938454afdbf1ae02.jpeg",
    "https://cdn.faire.com/fastly/85e8b7b638e9a4b4a0a3cd1f0188b04c582e81a8bc0f6e6dcb89f6a49678ff26.jpeg",
    "https://cdn.faire.com/fastly/ee6df4ae773ffcd141bd8ba360ec35610c801eafedc9d8e7a5375e90051251a5.jpeg",
    "https://cdn.faire.com/fastly/c520d6e604bf6f999f93db70e1da884df8b124542e4f79f4a5d0dcefd3d616e6.jpeg",
    "https://cdn.faire.com/fastly/6c6fb314211fe253a9650422beac2c4c697a51fb035c7953703ac1bff057a919.jpeg",
    "https://cdn.faire.com/fastly/1244aac5a695fbec0297b17e7e0d7f04e14da488f69d5f93a2472aa543f3a391.jpeg",
    "https://cdn.faire.com/fastly/f1f65dcdef63b1221b4f43f47411f27a7192d34cabb7ff037736af3beb35dc68.jpeg",
    "https://cdn.faire.com/fastly/e474054b5e419e38f4c79cca6f6d8913d4eaefea64cf84a53419a92e44b9699c.jpeg",
    "https://cdn.faire.com/fastly/2386b24ab0d7f4e8b2a731d966280de7add78f956eb188442ba7807b6d58d06f.jpeg",
    "https://cdn.faire.com/fastly/59cea3b0966079819185edccefca43af87617e5e99eabea6dc4cfe506b588125.jpeg",
    "https://cdn.faire.com/fastly/c800873e3174e6f00658a79b3600636300126f12b8c4a30534eba2b8cf8f047d.jpeg",
    "https://cdn.faire.com/fastly/48137882a09e24d1339de521b629a7e03d1f53a5d1ec230b7478852f5d7c1112.jpeg",
    "https://cdn.faire.com/fastly/0f63174233a80e87b3d910c098d64cf757f11066e6b7eee344978b202617c23d.jpeg",
    "https://cdn.faire.com/fastly/bb0c8d140fd05f6f8e9af680ce7da64194e4fa5486f8ef84c668d65999a6be03.jpeg",
    "https://cdn.faire.com/fastly/7b15e228b0f13988d11c64b1e8f33261417badf6bb8a8d377a1638989fb447f3.jpeg",
    "https://cdn.faire.com/fastly/7c0466c47c4dfafd4d31a1900e6b09c513775378ba4b0f7808562650022ee4bb.jpeg",
  ],
  priceDollars: 14.87,
  description:
    '• Size : 15" X 19"\n• Material : 100% Cotton\n• Perfect for carrying groceries, books, laptop, or beach essentials\n• Front Slip Pocket, One Metal Ring\n• Reinforced straps and bottom : Sturdy and built to carry heavy loads\n• Durable canvas tote bag featuring reinforced straps, a spacious interior, and a practical front pocket. Ideal for everyday use, work, or shopping with timeless minimalist style.',
  tags: [],
  msrpDollars: 29.74,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:14.056Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
